/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Tipo de Reserva
 */
export type TipoReserva = 'actividad' | 'evento';

export const TipoReserva = {
    Actividad: 'actividad' as TipoReserva,
    Evento: 'evento' as TipoReserva
};

